import { render, staticRenderFns } from "./OtherCharges.vue?vue&type=template&id=49ade31a"
import script from "./OtherCharges.vue?vue&type=script&lang=js"
export * from "./OtherCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports